export default __webpack_public_path__ + "static/media/arrow-trending-down.66a41568.svg";